<div
    class="diagnostic-window-card"
    *ngIf="window"
>
    <div class="card-top">
        <div class="card-monitor">
            <div class="monitor-icon">
                <mat-icon>wifi</mat-icon>
            </div>
            <div class="monitor-info">
                <div class="monitor-name">
                    <mat-icon class="pin-icon">location_on</mat-icon>
                    <span>{{ locationName }}</span>
                </div>
                <div class="monitor-check-in">
                    {{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.NEXT_CHECK_IN' | translate }}
                    {{
                        nextExpectedDiagnosticSession
                            ? (nextExpectedDiagnosticSession | date: customerDateFormat)
                            : ('LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.NOT_AVAILABLE' | translate)
                    }}
                </div>
            </div>
        </div>
        <div class="card-status">
            <span class="status-badge">{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.SCHEDULED' | translate }}</span>
            <mat-icon class="status-icon">pending_actions</mat-icon>
        </div>
    </div>
    <div class="card-divider"></div>
    <div class="card-bottom">
        <div class="card-details">
            <span>
                {{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.FREQ' | translate }}
                {{ frequencyHours }}{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.HOUR_SUFFIX' | translate }}
            </span>
            <span class="details-separator"></span>
            <span>
                {{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.WINDOW' | translate }}
                {{ windowDurationMinutes }}{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.MINUTES_SUFFIX' | translate }}
            </span>
            <span class="details-separator"></span>
            <span>
                {{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.WINDOW_EXPIRES' | translate }}
                {{ window.endTime | date: customerDateFormat }}
            </span>
        </div>
        <div class="card-actions">
            <button
                mat-icon-button
                class="edit-button"
                [matTooltip]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.EDIT_TOOLTIP' | translate"
                [attr.aria-label]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.EDIT_TOOLTIP' | translate"
                (click)="edit.emit()"
            >
                <mat-icon>edit</mat-icon>
            </button>
            <button
                mat-icon-button
                type="button"
                class="delete-button"
                [matTooltip]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.DELETE_TOOLTIP' | translate"
                [attr.aria-label]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.DELETE_TOOLTIP' | translate"
                (click)="deleteWindow.emit()"
            >
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>
</div>
